/**
 * Step 4 In funnel
 * Add contacts for treatment well(s) and offsets
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid, Card, CssBaseline, Container, Checkbox,
  Tabs, Tab
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import html2canvas from 'html2canvas';

import Header from '../../components/Header';
import Map from '../../components/Map';
import Search from '../../components/Search';
import Cube from '../../components/Cube';
import FpzTable from '../../components/FpzTable';
import ContactsTable from '../../components/ContactsTable';

import useCartofactWells from '../../hooks/useCartofactWells';
import {
  getSurveysIntersectingCylinder,
  metersToDegrees,
  generateSimpleDirectionalSurvey,
  generateFpzPolygon
} from '../../common/functions';
import { gisActions } from '../../actions';
import { SET_DIRECTIONAL_SURVEYS } from '../../actions/types';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const ContactsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    filter,
    cartofactWells,
    selectedTreatmentWells,
    ...fpzState
  } = useSelector(state => state.fpzReducer);

  useCartofactWells({
    toggleCartofactWells: true,
    boundingBox: fpzState?.map?.boundingBox,
    filter,
  });

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);
  const [cubeRender, setCubeRender] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  const [selected, setSelected] = useState(0);

  // Cube
  const [toggleFpzRadius, setToggleFpzRadius] = useState(true);
  const [toggleOffsetWells, setToggleOffsetWells] = useState(true);

  const [operators, setOperators] = useState([]);
  const [offsetOperators, setOffsetOperators] = useState([]);
  const [otherContacts, setOtherContacts] = useState([]);


  useEffect(() => {
    if (!selectedTreatmentWells || selectedTreatmentWells.length === 0) {
      navigate('/treatment'); // Redirect to home if no treatment wells selected
    }
    console.log('selectedTreatmentWells', selectedTreatmentWells);



    const tempOperators = Array.from(
      new Set(selectedTreatmentWells.map(well => well.operator))
    ).map(op => {
      const existing = fpzState?.contacts?.operators?.find(f => f.operator === op);
      console.log('existing', existing);
      return ({
        operator: op,
        contacts: existing?.contacts?.length > 0
          ? existing.contacts
          : [{ name: "", email: "", phone: "", designation: "" }]
      })
    });

    const tempOffsetOperators = Array.from(
      new Set(
        selectedTreatmentWells
          .flatMap(well => well?.offsetWells?.map(offsetWell => offsetWell.operator) || [])
      )
    ).map(op => {
      const existing = fpzState?.contacts?.offsetOperators?.find(f => f.operator === op);
      return ({
        operator: op,
        contacts: existing?.contacts?.length > 0
          ? existing.contacts
          : [{ name: "", email: "", phone: "", designation: "" }]
      })
    });

    setOperators(tempOperators);
    setOffsetOperators(tempOffsetOperators);

    console.log({ tempOperators, tempOffsetOperators });

  }, []);


  const handleViewReport = () => {
    navigate('/app/report')
  };

  return (
    <Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Typography variant="h6">
          Contacts for Treatment Wells and Offsets
        </Typography>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => { navigate('/app/offsets') }}
            disabled={selectedTreatmentWells?.length > 0 ? false : true}
          >
            Offsets
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={() => { navigate('/app/report') }}
            disabled={selectedTreatmentWells?.length > 0 ? false : true}
          >
            Report
          </Button>
        </Box>
      </Box>

      <Box>
        {operators.length > 0 && (
          <ContactsTable contactType="operators" initialData={operators} />
        )}
      </Box>
      <h3>
        Offset Operators
      </h3>
      <Box>
        {offsetOperators.length > 0 && (
          <ContactsTable contactType="offsetOperators" initialData={offsetOperators} />
        )}
      </Box>

    </Box>

  );
};

export default ContactsPage;
